import React from 'react';
import WhatsappLogo from '../images/whatsapp.png';
import { Typography } from 'antd';
import { WHATSAPP } from '../config/constants/whatsapp';

const { Link } = Typography;

const WhatsappButton = () => {
  return (
    <div className="wsp-button">
      <p>¿Consultas?</p>
      <Link href={WHATSAPP.CHAT_URI} target="_blank" >
        <img src={WhatsappLogo} alt="" style={{ height: '50px' }} />
      </Link>
    </div>
  );
};

export default WhatsappButton;
